import { graphql, rest } from "msw";
import {
  trainedModels,
  trainStatusActive
} from "./mockData";

const evaGql = graphql.link("http://localhost:5012/v1/graphql");

export const handlers = [
  evaGql.query("getTrainedModels", (req, res, ctx) => {
    return res(
      ctx.delay(1500),
      ctx.data(trainedModels)
    )
  }),

  evaGql.query("getTrainStatus", (req, res, ctx) => {
    const TEST_ONGOING = false;

    let ret;
    if (TEST_ONGOING) {
      ret = trainStatusActive;
    } else {
      ret = trainedModels;
    }
    return res(
      ctx.delay(1500),
      ctx.data(ret)
    )
  }),

  rest.post(`/modules/speech/model/train?domain_id=1`, (req, res, ctx) => {
    return res(
      ctx.json({
        domain_id: 1,
        model_id: 2
      })
    )
  }),

  rest.get(`http://localhost:5010/api/modules/speech/new-data`, (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.delay(1500),
      ctx.json({
        success: true,
        trainable_changes: true
      })
    )
  }),

  rest.post('http://localhost:5010/api/modules/speech/change-model', (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.delay(1500),
      ctx.json({
        success: true
      })
    )
  })
];
